import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  Col,
  Container,
  Row,
  Spinner,
  FormControl,
} from "react-bootstrap";
import TableData from "./component/tableData";
import { useSelector } from "react-redux";
import add_new from "../../../Assets/svg/add_new.svg";
import { get, updateToken } from "../../../helpers/api_helper";
import AddNewMasterPlanet from "./component/Modal/AddNewMasterPlanet";
import Pagination from "../../../components/Pagination";
import useCheckPermission from "../../../hooks/useCheckPermission";

const MasterPlanet = () => {
  const token = useSelector((state) => state.login.token);
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("create");
  const [masterPlanet, setMasterPlanet] = useState([]);
  const [selectedMasterPlanet, setSelectedMasterPlanet] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState("");

  const fetchMasterPlanet = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);
        const skip = page;
        const response = await get(
          `/planet/master?skip=${skip}&limit=${itemsPerPage}&search=${debouncedSearchQuery}`
        );
        if (response?.success) {
          setMasterPlanet(response?.data?.items || []);
          setTotalPages(response?.data?.totalPages || 0);
        } else {
          console.log("Failed to fetch master planet");
          setMasterPlanet([]);
        }
      } catch (error) {
        console.log(error);
        setMasterPlanet([]);
      } finally {
        setLoading(false);
      }
    },
    [itemsPerPage, debouncedSearchQuery]
  );

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchMasterPlanet(currentPage);
    }
  }, [token, fetchMasterPlanet, currentPage]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchQuery(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleAddMasterPlanet = () => {
    setModalMode("create");
    setSelectedMasterPlanet(null);
    setShowModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <>
      <AddNewMasterPlanet
        showModal={showModal}
        setShowModal={setShowModal}
        handleDataRefresh={() => fetchMasterPlanet(currentPage)}
        mode={modalMode}
        masterPlanetData={selectedMasterPlanet}
        resetFormOnClose={showModal}
      />

      <section className="userSec position-relative py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-center sectionHeader justify-content-between gap-10 flex-wrap filterBtns">
                <div className="left">
                  <h5 className="m-0 fw-sbold">Master Planet Details</h5>
                  <p className="m-0 text-muted py-1">
                    It is a long established fact that a reader will be
                    distracted by the readable
                  </p>
                </div>
                <div className="right d-flex align-items-center flex-wrap gap-10">
                  <FormControl
                    type="text"
                    placeholder="Search master planets"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    className="rounded-pill"
                    style={{ width: "200px" }}
                  />
                  {useCheckPermission("masterPlanet", "CREATE") && <Button
                    onClick={handleAddMasterPlanet}
                    className="d-flex align-items-center justify-content-center rounded-pill"
                  >
                    Add Master Planet
                    <span className="icn ms-2">
                      <img src={add_new} alt="" />
                    </span>
                  </Button>}
                </div>
              </div>
            </Col>

            <Col lg="12" className="my-2">
              <div className="commonTable scrollable-table-container">
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "100px" }}
                  >
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : masterPlanet.length > 0 ? (
                  <>
                    <TableData
                      masterPlanet={masterPlanet}
                      setRefresh={() => fetchMasterPlanet(currentPage)}
                    />
                    {totalPages > 1 && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    )}
                  </>
                ) : (
                  <div className="d-flex justify-content-center align-items-center my-5">
                    <p>No master planet data available.</p>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default MasterPlanet;
